export default __webpack_public_path__ + "static/media/algebra.5eb6869a.jpg";